import { render } from "./Annotation.vue?vue&type=template&id=5aaf0202&scoped=true"
import script from "./Annotation.vue?vue&type=script&lang=js"
export * from "./Annotation.vue?vue&type=script&lang=js"

import "./Annotation.vue?vue&type=style&index=0&id=5aaf0202&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aaf0202"]])

export default __exports__